/**
 * Typen des Einwilligungs-Gates.
 *
 * Die Formen spiegeln die Rueckgaben von get_consent_state() und
 * record_consent() (Migration 172). Der Supabase-Client der User-App ist
 * ungetypt (createClient ohne Database-Generic), die Zuordnung passiert
 * deshalb hier - an einer Stelle statt an jeder Aufrufstelle.
 */

export type ConsentType = 'privacy' | 'terms' | 'health_data';

export type ConsentDecision = 'granted' | 'declined' | 'withdrawn' | 'deferred';

/** Quelle der Entscheidung. 'import' setzt nur die Migration, nicht der Client. */
export type ConsentSource = 'signup' | 'gate' | 'profile';

export interface ConsentLatestEntry {
  decision: ConsentDecision;
  version: string;
  decided_at: string;
  deferred_until: string | null;
}

export interface ConsentState {
  versions: Record<ConsentType, string>;
  /** Juengste Entscheidung je Art. Fehlt ein Schluessel, gab es nie eine. */
  latest: Partial<Record<ConsentType, ConsentLatestEntry>>;
  requires_privacy: boolean;
  requires_terms: boolean;
  /** Bleibt true, solange die Einwilligung fehlt - auch waehrend eines Aufschubs. */
  requires_health: boolean;
  /** Gesetzt, solange ein Aufschub laeuft. Das Gate haelt dann still. */
  health_deferred_until: string | null;
  can_defer_health: boolean;
  server_time: string;
}

/**
 * SQLSTATE, mit dem record_consent() eine veraltete Textfassung abweist.
 * Eigener Code statt Textvergleich - die Fehlermeldung ist uebersetzbar,
 * der Code nicht.
 */
export const CONSENT_VERSION_STALE_CODE = 'PP001';
